import { isValidWebAppLocale } from '~/utils/guards/isValidWebAppLocale';

/**
 * Resolves the webapp locale for the current request (e.g. global page settings).
 * Prefers the locale from the URL over generic fallbacks so error pages match the path.
 */
export function resolveWebappLocaleFromRequest(): string {
  const { $locale, $requestedLocale } = useNuxtApp();

  const pathLocale = import.meta.server
    ? useRequestURL().pathname.split('/')[1]?.toLowerCase()
    : (useRoute().params.locale?.toString().toLowerCase() ?? '');

  const candidates = [
    $requestedLocale?.value,
    pathLocale,
    $locale.value
  ].filter((value): value is string => Boolean(value));

  for (const candidate of candidates) {
    if (isValidWebAppLocale(candidate)) {
      return candidate;
    }
  }

  return $locale.value;
}
